<script>
import router from "@/router";
import { SimpleBar } from "simplebar-vue3";
import { layoutComputed } from "@/state/helpers";

import NavBar from "@/components/nav-bar";
import Menu from "@/components/menu.vue";
// import Menu from "@/components/menu-backup.vue";
import RightBar from "@/components/right-bar";
import Footer from "@/components/footer";
localStorage.setItem("hoverd", false);

/**
 * Vertical layout
 */
export default {
  components: { NavBar, RightBar, Footer, SimpleBar, Menu },
  data() {
    return {
      isMenuCondensed: false,
    };
  },
  computed: {
    ...layoutComputed,
  },
  created: () => {
    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-layout-size", "boxed");
  },
  methods: {
    initActiveMenu() {
      if (
        document.documentElement.getAttribute("data-sidebar-size") ===
        "sm-hover"
      ) {
        localStorage.setItem("hoverd", true);
        document.documentElement.setAttribute(
          "data-sidebar-size",
          "sm-hover-active"
        );
      } else if (
        document.documentElement.getAttribute("data-sidebar-size") ===
        "sm-hover-active"
      ) {
        localStorage.setItem("hoverd", false);
        document.documentElement.setAttribute("data-sidebar-size", "sm-hover");
      } else {
        document.documentElement.setAttribute("data-sidebar-size", "sm-hover");
      }
    },
    toggleMenu() {
      document.body.classList.toggle("sidebar-enable");

      if (window.screen.width >= 992) {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
          document.body.classList.remove("vertical-collpsed");
        });
        document.body.classList.toggle("vertical-collpsed");
      } else {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
        document.body.classList.remove("vertical-collpsed");
      }
      this.isMenuCondensed = !this.isMenuCondensed;
    },
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },
  },
  mounted() {
    if (localStorage.getItem("hoverd") == "true") {
      document.documentElement.setAttribute(
        "data-sidebar-size",
        "sm-hover-active"
      );
    }
    document.getElementById("overlay").addEventListener("click", () => {
      document.body.classList.remove("vertical-sidebar-enable");
    });
  },
};
</script>

<template>
  <div id="layout-wrapper">
    <NavBar />
    <div>
      <!-- ========== Left Sidebar Start ========== -->
      <!-- ========== App Menu ========== -->
      <div class="app-menu navbar-menu">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <!-- Dark Logo-->
          <router-link to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img src="@/assets/images/logo-sm.png" alt="" height="22" />
              <!-- <h3 class="mt-3 text-light">XM</h3> -->
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo-dark.png" alt="" height="17" />
              <!-- <h3 class="mt-3 text-light">XMART CRM</h3> -->
            </span>
          </router-link>
          <!-- Light Logo-->
          <router-link to="/" class="logo logo-light">
            <span class="logo-sm">
              <img src="@/assets/icon_new.png" alt="" height="25" />
            </span>
            <span class="logo-lg">
              <img
                src="@/assets/icon_new.png"
                class="mt-3"
                alt=""
                width="150"
              />
              <!-- <h3 class="mt-3" style="color: white;">XMART CRM</h3> -->
            </span>
          </router-link>
          <button
            type="button"
            class="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
            id="vertical-hover"
            @click="initActiveMenu"
          >
            <i class="ri-record-circle-line"></i>
          </button>
        </div>

        <SimpleBar id="scrollbar" class="h-100" ref="scrollbar">
          <Menu></Menu>
        </SimpleBar>
        <div class="sidebar-background"></div>
      </div>
      <!-- Left Sidebar End -->
      <!-- Vertical Overlay-->
      <div class="vertical-overlay" id="overlay"></div>
    </div>
    <!-- ============================================================== -->
    <!-- Start Page Content here -->
    <!-- ============================================================== -->

    <div class="main-content">
      <div class="page-content">
        <!-- Start Content-->
        <div class="container-fluid">
          <slot />
        </div>
      </div>
      <Footer />
    </div>
    <RightBar />
  </div>
</template>

<style scoped>
/* Dark Mode Improvements */
[data-layout-mode="dark"] .navbar-brand-box {
  background: linear-gradient(135deg, #1a1d29 0%, #252936 100%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

[data-layout-mode="dark"] .app-menu {
  background: #1a1d29;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.3);
}

[data-layout-mode="dark"] .sidebar-background {
  background: linear-gradient(180deg, #1a1d29 0%, #12151f 100%);
}

/* Button hover di dark mode */
[data-layout-mode="dark"] .btn-vertical-sm-hover {
  color: #e9ecef;
}

[data-layout-mode="dark"] .btn-vertical-sm-hover:hover {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

/* Main content dark mode */
[data-layout-mode="dark"] .main-content {
  background: #12151f;
}

[data-layout-mode="dark"] .page-content {
  background: #12151f;
  color: #e9ecef;
}

/* Container fluid dark mode */
[data-layout-mode="dark"] .container-fluid {
  color: #e9ecef;
}

/* Scrollbar dark mode */
[data-layout-mode="dark"] #scrollbar :deep(.simplebar-scrollbar::before) {
  background: rgba(255, 255, 255, 0.2);
}

[data-layout-mode="dark"] #scrollbar :deep(.simplebar-scrollbar:hover::before) {
  background: rgba(255, 255, 255, 0.3);
}

/* Vertical overlay dark mode */
[data-layout-mode="dark"] .vertical-overlay {
  background: rgba(0, 0, 0, 0.7);
}

/* Text improvements untuk readability */
[data-layout-mode="dark"] * {
  color: inherit;
}

[data-layout-mode="dark"] h1,
[data-layout-mode="dark"] h2,
[data-layout-mode="dark"] h3,
[data-layout-mode="dark"] h4,
[data-layout-mode="dark"] h5,
[data-layout-mode="dark"] h6 {
  color: #f8f9fa;
}

[data-layout-mode="dark"] p,
[data-layout-mode="dark"] span,
[data-layout-mode="dark"] div {
  color: #e9ecef;
}

[data-layout-mode="dark"] a {
  color: #7c9ff0;
}

[data-layout-mode="dark"] a:hover {
  color: #a5bfff;
}

/* Card dan box di dark mode */
[data-layout-mode="dark"] .card {
  background: #1e2130;
  border-color: rgba(255, 255, 255, 0.05);
  color: #e9ecef;
}

[data-layout-mode="dark"] .card-header {
  background: #252936;
  border-bottom-color: rgba(255, 255, 255, 0.05);
  color: #f8f9fa;
}

/* Table dark mode */
[data-layout-mode="dark"] .table {
  color: #e9ecef;
  border-color: rgba(255, 255, 255, 0.05);
}

[data-layout-mode="dark"] .table thead th {
  color: #f8f9fa;
  background: #252936;
  border-color: rgba(255, 255, 255, 0.05);
}

[data-layout-mode="dark"] .table tbody tr {
  border-color: rgba(255, 255, 255, 0.05);
}

[data-layout-mode="dark"] .table tbody tr:hover {
  background: rgba(255, 255, 255, 0.03);
}

/* Form elements dark mode */
[data-layout-mode="dark"] .form-control,
[data-layout-mode="dark"] .form-select {
  background: #252936;
  border-color: rgba(255, 255, 255, 0.1);
  color: #e9ecef;
}

[data-layout-mode="dark"] .form-control:focus,
[data-layout-mode="dark"] .form-select:focus {
  background: #2d3142;
  border-color: #7c9ff0;
  color: #f8f9fa;
}

[data-layout-mode="dark"] .form-label {
  color: #e9ecef;
}

/* Badge dan label dark mode */
[data-layout-mode="dark"] .badge {
  border: 1px solid rgba(255, 255, 255, 0.1);
}

/* Modal dark mode */
[data-layout-mode="dark"] .modal-content {
  background: #1e2130;
  color: #e9ecef;
  border-color: rgba(255, 255, 255, 0.1);
}

[data-layout-mode="dark"] .modal-header {
  border-bottom-color: rgba(255, 255, 255, 0.1);
}

[data-layout-mode="dark"] .modal-footer {
  border-top-color: rgba(255, 255, 255, 0.1);
}
</style>